<div class="map"
     leaflet
     [leafletOptions]="leafletOptions"
     [leafletLayers]="leafletLayers"
     (leafletMapReady)="onMapReady($event)"
     (leafletClick)="onMapClick($event)"
>
</div>
